<template>
    <div class="mMobileMaridaje-container" v-observe-visibility="startAnimate">
        <div class="mMobileTitles">
            <img class="mMobileMaridaje" :src="neonMaridajeMobile" :class="{animate: animate}" alt="Tecate 0.0 es ideal para maridar con comida callejera ">
            <img class="mMobileRedNeon" :src="tktRedNeonLightMobile" :class="{animate: animate}" alt="Tecate 0.0 es ideal para maridar con comida de puestos y toda la gastronomia mexicana que puedas encontrar en las calles de México">
        </div>
        <div class="mMobilefoodsExamples">
            <div class="imgContentMobile">
                <div class="imgFoodsMobile">
                    <p class="tittleImgMobile">TACOS</p>
                        <img class="imgMaridajeMobile" :src="antojitos" alt="Necesitas 0.0 pretextos para comer Tacos con la NUEVA Tecate 0.0">
                    <p class="tittleImg2Mobile">¡De todo tipo!</p>
                </div>
                <div class="imgFoodsMobile">
                    <P class="tittleImgMobile">TORTAS</P>
                        <img class="imgMaridajeMobile" :src="botanas" alt="Necesitas 0.0 pretextos para comer Tortas con la NUEVA Tecate 0.0">
                    <p class="tittleImg2Mobile">¡Lo que más<br> se te antoje!</p>
                </div>
            </div>
            <div class="imgContentMobile">
                <div class="imgFoodsMobile">  
                    <p class="tittleImgMobile">ANTOJITOS</p>
                        <img  class="imgMaridajeMobile" :src="tacos" alt="Necesitas 0.0 pretextos para disfrutar de tus antojitos favoritos con la NUEVA Tecate 0.0">
                    <p class="tittleImg2Mobile">¡De los que tú<br> ya conoces!</p>
                </div>
                <div class="imgFoodsMobile">
                    <p class="tittleImgMobile">BOTANA</p>
                        <img class="imgMaridajeMobile" :src="tortas" alt="Necesitas 0.0 pretextos para disfrutar de tus botanas favoritas con la NUEVA Tecate 0.0">
                    <p class="tittleImg2Mobile">¡La de siempre!</p>
                </div>
            </div>
        </div>
        <div class="bannerMaridajeMobile"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bowser from "bowser";
import neonMaridajeMobile from '@/assets/tkt-maridaje/MARIDAJE-NEON.png';
import tktRedNeonLightMobile from '@/assets/tkt-maridaje/TECATE-NEON-ROJO.png';
import antojitos from '@/assets/tkt-maridaje/MARIDAJE_MOBILE/ANTOJITOS.png';
import botanas from '@/assets/tkt-maridaje/MARIDAJE_MOBILE/BOTANAS.png';
import tacos from '@/assets/tkt-maridaje/MARIDAJE_MOBILE/TACOS.png';
import tortas from '@/assets/tkt-maridaje/MARIDAJE_MOBILE/TORTAS.png';

export default {
    name: "MobileElaboration",
    data() {
        return {
            animate: false,
            isSafari: false,
            neonMaridajeMobile,
            tktRedNeonLightMobile,
            antojitos,
            botanas,
            tacos,
            tortas
        };
    },

    computed: {
        ...mapGetters(["isLoaded"]),
    },

    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
    },

    components: {},
    mounted() {
    },

    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName() == 'Safari') {
            this.isSafari = true
        }
    }
}

</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/MobileMaridaje.scss";
</style>